import { post } from '@/common/request';

const labelAuditMap = new Map([
  ['list', '/tenant/examineLabel/page'],
  ['detail', '/tenant/examineLabel/detail'],
  ['reject', '/tenant/examineLabel/reject'],
  ['pass', '/tenant/examineLabel/pass'],
]);
export interface SearchParams {
  tntPlaceName?: string;	 // 项目名称
  tntPlaceId?: number; // 场地ID
  tntSpotName?: string;	// 点位名称
  tntSpotId?:	number;	// 点位ID
  tntPlaceCategoryId?: number; // 项目类目
  status?: Status; // 审核状态
}

type Status = 1 | 2 | 3 // 1-待审核 2-审核通过 3-审核拒绝

interface LabelAuditInfo {
  id?: number; // 审核ID
labelClassificationNames:	string; // 标签分类名称
tntSpotName?:	string; // 点位名称
tntPlaceName?: string; // 项目名称
categoryName?: string; // 类目名称
submitDate?: string	 // 审核时间
}
interface Respone {
  pagaSize?: number;
  pageNo?: number;
  objectList?: LabelAuditInfo[];
}

interface LabelClassification {
  labelClassificationId?:	number; // 分类ID
  labelClassificationName?:	string; // 分类名称
  submitLabelList?:	string; // 审核标签
  oldLabelList?: any[]	// 原标签
  appendix?: string; // 附件
  remark?: string; // 备注
  rejectReason?: string; // 拒绝原因
  isPass?: boolean; // 是否通过
}



export function getList(page: number, size: number, searchParams: SearchParams): Promise<Respone> {
  return post(labelAuditMap.get('list'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
}

export function detail(id: number): Promise<{tntPlaceName?: string, labelClassificationList?: LabelClassification }> {
  return post(labelAuditMap.get('detail'), { id }, { proxyApi: '/resserv', needHint: true });
}

export function pass(id: number, examineLabelSubIdList: number[]) {
  return post(labelAuditMap.get('pass'), { id, examineLabelSubIdList }, { proxyApi: '/resserv', needHint: true });
}



export default labelAuditMap;


/**
 * 【标签审核】列表
 * https://yapi.lanhanba.com/project/399/interface/api/39206
 */
export async function getExamineLabelList(params?: any) {
  return post('/tenant/examineLabel/page', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【标签审核】详情
 * https://yapi.lanhanba.com/project/399/interface/api/39234
 */
export async function getExamineLabelDetail(params?: any) {
  return post('/tenant/examineLabel/detail', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【标签审核】通过
 * https://yapi.lanhanba.com/project/399/interface/api/39227
 */
export async function postExamineLabelPass(params?: any) {
  return post('/tenant/examineLabel/pass', params, { proxyApi: '/resserv', needHint: true });
}

/**
 * 【标签审核】拒绝
 * https://yapi.lanhanba.com/project/399/interface/api/39213
 */
export async function postExamineLabelReject(params?: any) {
  return post('/tenant/examineLabel/reject', params, { proxyApi: '/resserv', needHint: true });
}
